import React, { Component } from 'react';
import './index.less';

class Dashboard extends Component {
  constructor() {
    super();
  }
  componentDidMount() {}

  render() {
    return <div>Dashboard</div>;
  }
}

export default Dashboard;
